var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14227 2.45946C7.53038 1.81039 8.46999 1.81039 8.85809 2.45946L14.8542 12.4868C15.2527 13.1534 14.7724 14.0005 13.9958 14.0005H2.00458C1.22796 14.0005 0.747622 13.1534 1.14618 12.4868L7.14227 2.45946ZM7.99969 10.2192C7.6317 10.2194 7.33368 10.5106 7.33368 10.8696C7.33378 11.2286 7.63177 11.5198 7.99969 11.52C8.36779 11.52 8.66658 11.2287 8.66669 10.8696C8.66669 10.5105 8.36785 10.2192 7.99969 10.2192ZM7.99969 5.66649C7.46194 5.66668 7.03986 6.12772 7.08563 6.66356L7.27704 8.90477C7.30921 9.2802 7.62291 9.56867 7.99969 9.56884C8.37663 9.56884 8.69116 9.28032 8.72333 8.90477L8.91473 6.66356C8.96051 6.12761 8.5376 5.66649 7.99969 5.66649Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.6cf1ea805c79a7a662c7006074bdf792.svg";
export { ForwardRef as ReactComponent };